export enum OrderType {
  PreOrder = 'Pre-Order',
  ReOrder = 'Re-Order',
  MultiplePreOrder = 'Pre-Order-Multiple',
  DropShip = 'Drop ship',
  ReturnOrder = 'Return',
  WarrantyOrder = 'Warranty',
  Bulks = 'Bulks',
  Replacement = 'Replacement',
  DemoSets = 'Demo Sets',
  ConsignmentReturn = 'Consignment Return',
  ConsignmentSale = 'Consignment Sale',
  EventOrder = 'Event Order',
  ExperienceItems = 'Experience Items',
  LastSeason = 'Last Season',
  MarketingMaterial = 'Marketing Material',
  MediaSamples = 'Media Samples',
  SalesTeamSamples = 'Sales Team Samples',
  Sponsorship = 'Sponsorship',
  Subscription = 'Subscription',
  /**
   * A tailored, seasonalized collection (e.g. `SP FW27`, `SP SS27`) with its own
   * dedicated sell-in window, accessible only to eligible accounts.
   *
   * - Cannot be mixed with regular pre-order items in the same order.
   * - Cannot be re-ordered.
   * - Gated by the `SPECIAL_PROJECTS_ENABLED` feature flag.
   *
   * Maps to {@link OrderTypeEnum.PreOrder} in Dynamics (no native SP type exists).
   */
  SpecialProjects = 'Special Projects',
  Unknown = '', // used as default value in the mapper to avoid undefined
}
